import React from 'react'
import Navbar from '../components/Navbar'
import Place from '../components/Place'

const PlaceToStay = () => {
  return (
    <div>
        <Navbar />
        <Place />
        
    </div>
  )
}

export default PlaceToStay